import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { scrollToError } from '@/js/lib/helper/validate';
import { signin, signup } from '@/js/lib/api/user';
import { checkEmailExistence } from '@/js/lib/api/validate';
import { useCommonStore } from '@/js/lib/store/common';
import { useUserStore } from '@/js/lib/store/user';
import { info, loading } from '@/js/lib/ui';
import IButton from '@/js/components/molecules/IButton.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';

interface FormData {
  email: string;
  password: string;
  memberName: string;
  remember: boolean;
  mailmagazine: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SigninSignupForm',
  props: {
    value: { default: '' },
    email: { default: '' },
    memberName: { default: '' },
    transactionToken: { default: '' },
    oauthProvider: { default: undefined },
    isModal: { type: Boolean },
    from: { default: '' }
  },
  emits: ["close", "input", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
  (e: 'input', name: string): void;
  (e: 'submit', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, email: string, memberName: string, transactionToken: string, oauthProvider: string, isModal?: boolean, from: string };



const socialProviders = [
  {
    id: 'facebook',
    label: 'Facebook',
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path d="M48 24C48 10.7438 37.2562 0 24 0C10.7438 0 0 10.7438 0 24C0 35.9813 8.775 45.9094 20.25 47.7094V30.9375H14.1562V24H20.25V18.7125C20.25 12.6984 23.8313 9.375 29.3156 9.375C31.9406 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6594C28.6781 15.75 27.75 17.6016 27.75 19.5V24H34.4062L33.3422 30.9375H27.75V47.7094C39.225 45.9094 48 35.9813 48 24Z" fill="#1877F2"/><path d="M33.3422 30.9375L34.4062 24H27.75V19.5C27.75 17.6016 28.6781 15.75 31.6594 15.75H34.6875V9.84375C34.6875 9.84375 31.9406 9.375 29.3156 9.375C23.8313 9.375 20.25 12.6984 20.25 18.7125V24H14.1562V30.9375H20.25V47.7094C21.4734 47.9016 22.725 48 24 48C25.275 48 26.5266 47.9016 27.75 47.7094V30.9375H33.3422Z" fill="white"/></svg>',
  },
  {
    id: 'twitter',
    label: 'X',
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 1200 1227"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="black"/></svg>',
  },
];
const { isWebView } = useCommonStore();
const userStore = useUserStore();
const observer = ref();
const emailRef = ref();
const formData = ref<FormData>({
  email: props.email,
  password: '',
  remember: true,
  memberName: props.memberName,
  mailmagazine: true,
});
const isSignin = computed(() => props.value === 'signin');
const pageTitle = computed(() => (isSignin.value ? 'ログイン' : '会員登録'));
const connectArr = computed(() =>
  socialProviders.map((item) => {
    const from = props.from ? `?from=${props.from}` : '';
    const url = `/${props.value}/with/${item.id}${from}`;
    return {
      id: item.id,
      label: item.label,
      svg: item.svg,
      url,
    };
  }),
);
const helpLink = computed(() => (isSignin.value ? 'https://help.iichi.com/hc/ja/articles/360000013721' : 'https://help.iichi.com/hc/ja/articles/200196409'));
const socialProvider = computed(() => (provider) => socialProviders.find((p) => p.id === provider));
const onSubmit = async () => {
  const isValid = await observer.value.validate();
  if (!isValid) {
    scrollToError();
    return;
  }
  const emailExistence = await checkEmailExistence({ email: formData.value.email });
  if (!isSignin.value && emailExistence !== true) {
    emailRef.value.$refs.provider.applyResult({
      errors: [emailExistence],
    });
    scrollToError();
    return;
  }
  loading({
    asyncFunc: async () => {
      if (isSignin.value) {
        const res = await signin({
          email: formData.value.email,
          password: formData.value.password,
          remember: formData.value.remember,
        });
        if (res.error === false) {
          userStore.setSignined();
          if (props.isModal) {
            emit('submit', props.value);
          } else {
            window.location.href = props.from || '/';
          }
        } else {
          info('メールアドレス、もしくはパスワードが違います。', { fadeOut: true });
        }
      } else {
        await signup({
          email: formData.value.email,
          password: formData.value.password,
          memberName: formData.value.memberName,
          subscribeNewsletter: formData.value.mailmagazine,
          transactionToken: props.transactionToken,
        });
        userStore.setSignined();
        if (props.isModal) {
          emit('submit', props.value);
        } else {
          window.location.href = props.from || '/';
        }
      }
    },
  });
};
const onClick = (name: string, $event) => {
  if (props.isModal) {
    emit('input', name);
  } else {
    window.location.href = $event.target.href;
  }
};
const close = () => {
  emit('close');
};

return { __sfc: true,props, emit, socialProviders, isWebView, userStore, observer, emailRef, formData, isSignin, pageTitle, connectArr, helpLink, socialProvider, onSubmit, onClick, close, signup, IButton, ITextField }
}

})